import { TableHeadersType } from '../tableHeadersType';

export const TIMESHEET_VS_SCHEDULING_MONTHLY_REPORT_HEADERS: TableHeadersType[] = 
// 

[
  {
    "label": "User",
    "value": "user",
    "id":"1"
  
  },
  {
    "label": "Billable & Non-Billable",
    "value": "billable ",
    "id":"2"

  },
  {
    "label": "Scheduled",
    "value": "scheduled ",
    "id":"3"

  },
  {
    "label": "Billable & Non-Billable",
    "value": "billable ",
    "id":"4"

  },
  {
    "label": "Scheduled",
    "value": "scheduled ",
    "id":"5"

  },
  {
    "label": "Billable & Non-Billable",
    "value": "billable ",
    "id":"6"

  },
  {
    "label": "Scheduled",
    "value": "scheduled ",
    "id":"7"

  },
];

export const TIMESHEET_SCHEDULING_BILLABLE_REPORT_HEADERS : TableHeadersType[]=[
  {
    "label": "User",
    "value": "user",
    "id":"1"
  
  },
  {
    "label": "Billable",
    "value": "billable ",
    "id":"22"

  },
  {
    "label": "Billable",
    "value": "billable ",
    "id":"33"

  },
  {
    "label": "Billable",
    "value": "billable ",
    "id":"44"

  }
]